import "./App.css";
import logo from "./assets/migas.jpg";

type LPConfig = {
  header: string;
  title: string;
  title2: string;
  subtitle: string;
  ctaButton: string;
  ctaSubtitle: string;
  footer: string;
};

const CONFIG: Record<string, LPConfig> = {
  "ph-geral": {
    header: "🎯 MELHORES PROMOÇÕES E CUPONS DO UNIVERSO FEMININO",
    title: "🚨 GRUPO VIP 🚨",
    title2: "100% GRATUITO",
    subtitle: "Produtos com 50% 60% 70% OFF 🥰",
    ctaButton: "QUERO PARTICIPAR",
    ctaSubtitle: "✨ JÁ SOMOS +100 MIL MEMBROS ✨",
    footer: "Direitos Reservados",
  },
};

function App() {
  const config = CONFIG["ph-geral"];

  return (
    <div className="container">
      <header className="header">
        <h1>{config.header}</h1>
      </header>

      <main className="main-content">
        <div className="vip-group-title">
          <p>{config.title}</p>
          <p>{config.title2}</p>
        </div>

        <div className="discount-text">{config.subtitle}</div>

        <div className="cta-container">
          <div className="icon-container">
            <img src={logo} alt="Shopping Bag" className="shopping-bag-icon" />
          </div>

          <a
            // href="https://chat.whatsapp.com/FSJtdIWqcXr7PULMkLKCSP"
            href="http://linktr.it/migas"
            className="cta-button animated-fast animated tada"
          >
            {config.ctaButton}
          </a>

          <div className="members-count">{config.ctaSubtitle}</div>
        </div>
      </main>

      <footer className="footer">{config.footer}</footer>
    </div>
  );
}

export default App;
